/*
 * @Author: mina.min
 * @Date: 2025-06-17 20:02:12
 * @LastEditors: mina.min
 * @LastEditTime: 2025-08-27 14:45:15
 * @FilePath: /OTA-frontend/src/services/device.ts
 * @Description:
 */
import axios from 'axios'

const BASE_URL = 'https://wi4l39akng.execute-api.ap-southeast-1.amazonaws.com/dev'

export interface Hardware {
  hardwareName: string
  hardwareVersion: number
}

export interface Software {
  softwareName: string
  softwareVersion: number
}

export interface Device {
  sn: string
  lastUpdatedTime: string
  hardwareList: Hardware[]
  softwareList: Software[]
}

export interface DeviceListResponse {
  code: string
  info: string
  data: {
    total: number
    pageSize: number
    list: Device[]
    pageNum: number
  }
}

export const getDeviceList = async (params: {
  pageNum?: string
  pageSize?: string
}): Promise<DeviceListResponse> => {
  const response = await axios.get(`${BASE_URL}/OTA-DeviceHandler/list`, { params })
  return response.data
}

export interface DeleteDeviceRequest {
  vehicleId: string
}
export interface DeleteDeviceResponse {
  code: string
  info: string
  data: string
}

export const deleteDevice = async (data: DeleteDeviceRequest): Promise<DeleteDeviceResponse> => {
  try {
    const response = await axios.post(
      `${BASE_URL}/OTA-DeviceHandler/delete`,
      JSON.stringify(data),
      { headers: { 'Content-Type': 'text/plain' } }
    )
    return response.data
  } catch (error) {
    console.error('删除设备失败:', error)
    throw error
  }
}
